<!-- 
    描述：审核待办  -- 专家 -- 项目经验
    时间：2020/10/30
    Created by zl
-->
<template>
	<div>
		<el-form v-if="contactInfo.length >= 1"
				 label-width="140px"
				 size="small">
			<el-row>
				<div v-for="(itme, index) in contactInfo"
					 :key="'contactInfo' + index"
					 class="item-box clearfix">
					<el-row>
						<el-col :span="12">
							<el-form-item label="所属公司：">
								<el-input v-model="itme.company"
										  disabled></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="时间：">
								<el-col :span="11">
									<el-date-picker v-model="itme.startTime"
													type="date"
													disabled></el-date-picker>
								</el-col>
								<el-col :span="2"
										class="text-center">到</el-col>
								<el-col :span="11">
									<el-date-picker v-model="itme.endTime"
													type="date"
													disabled></el-date-picker>
								</el-col>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="项目：">
								<el-input v-model="itme.project"
										  disabled></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="24">
							<el-form-item label="项目描述：">
								<el-input v-model="itme.projectDes"
										  type="textarea"
										  :rows="5"
										  disabled
										  maxlength="30"
										  show-word-limit></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="24">
							<el-form-item label="责任描述：">
								<el-input v-model="itme.dutyDes"
										  type="textarea"
										  :rows="5"
										  disabled
										  maxlength="30"
										  show-word-limit></el-input>
							</el-form-item>
						</el-col>
					</el-row>
				</div>
			</el-row>
		</el-form>
		<div class="text-center"
			 v-else>暂无数据</div>
	</div>
</template>
<script>
export default {
	props: {
		contactInfo: {
			type: Array,
			default: () => {
				return []
			},
		},
	},
	data() {
		return {}
	},
	methods: {},
}
</script>
<style lang="less" scoped></style>
